import React, { ReactNode } from "react";
import {  RadioGroup, RadioGroupProps } from "@mui/material";

export type CustomRadioGroupComponentProps = RadioGroupProps & {
  controldisabled?: boolean;
  useFullWidth?: boolean;
  children: ReactNode;
  size?: string;
  height?: number | string;
  width?: number | string;
};

export const CustomRadioGroupComponent = ({
  size = "small",
  useFullWidth = true,
  controldisabled,
  children,
  ...others
}: CustomRadioGroupComponentProps) => (
  <RadioGroup
    id="CustomRadioGroupComponent"
    sx={{
      height: others.height,
      width: others.width,
    }}
 
    {...others}
  >
    {children}
  </RadioGroup>
);

export default CustomRadioGroupComponent;
